import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridPanel from "../../components/GridPanel";
import { useTextResources } from "../../language";
import { Icon } from "semantic-ui-react";
import { GetReservationTotals } from "../../api/services/pms";
import { CurrencyIds } from "../../components/shared/currencies";
import { ReservationStatusesEnums, RoomStatusTypes } from "../../components/shared/statustypes";
import { Reservations } from "../../api/services/next";
import "./style.css";
import moment from "moment";
import { ReservationTypes } from "../../components/shared/constants";
import { useCurrentHotel } from "../../hooks/useCurrentHotel";

export default function Arrivals({ HotelId, onSelectReservation }) {
  const currentHotel = useCurrentHotel();
  const text = useTextResources();
  const [reservations, setReservations] = useState([]);

  const gridOptions = {
    columns: [
      { name: "Number", title: text("Number") },
      { name: "GuestName", title: text("Guest")},
      { name: "Customer", title: text("Customer")},
      { name: "RoomNumber", title: text("RoomNumber") },
      { name: "RoomStatus", title: text("Status"), formatter: ({row}) => <span className={`status-icon ${RoomStatusTypes[row.RoomStatus]}`}></span> },
      {
        name: "",
        title: text("CheckIn"),
        formatter: ({ row }) => {
          return <Icon size="large" name="angle right" onClick={() => onSelectReservation(row)} />;
        },
      },
    ],
    filtering: true,
    showFilter: true,
    noVirtualTable:true
  };

  useEffect(() => {
    (async () => {
      let CurrentBusinessDate = moment(currentHotel?.HotelParameter?.CurrentBusinessDate);
      let fetchedReservations = await Reservations.Search({ 
        HotelId,
        IncludeGuest: true,
        IncludeGuestImages: true,
        IncludeReservationCompanyAgent: true,
        Statuses: [ReservationStatusesEnums.Reserved, ReservationStatusesEnums.Arrived],
        ReservationTypes: [ReservationTypes.Individuals ,ReservationTypes.GroupMembers],
        CheckInDateRange: [CurrentBusinessDate.startOf("day").toISOString(), CurrentBusinessDate.endOf("day").toISOString()],
      });
      const reservationsIds = fetchedReservations.map(s => s.Id);
      const totals = await GetReservationTotals({
        ReservationIDs: reservationsIds,
        HotelID: HotelId,
        TargetCurrencyId: currentHotel?.MainCurrencyId || CurrencyIds["USD"]
      });
      setReservations(fetchedReservations.map(reservation => {
        let reservationTotals = totals.find(t => t.ReservationID === reservation.Id) || {};
        delete reservationTotals.HotelID;
        let { TotalAmountDebitAfterTax, TotalAmountCreditAfterTax } = reservationTotals
        return {...reservation, ...reservationTotals, TotalAmountDebitAfterTax, TotalAmountCreditAfterTax}
      }));
    })();
  }, []);

  return (
    <div className="reception-anywhere-reservations" style={{overflow: "auto"}}>
      <GridPanel data={reservations} options={gridOptions}/>      
    </div>
  );
}

Arrivals.propTypes = {
  onSelectReservation: PropTypes.func,
  HotelId: PropTypes.number,
};
